import React from 'react';

/**
 * Use that hook as useEffect, but it will not trigger on the initial dependency set, so it will not fire before variable has changed.
 * @param effect - function to execute on variable change, same as in useEffect
 * @param deps - dependencies array, same as in useEffect
 */
export function useDidUpdateEffect(effect: () => void | (() => void), deps: unknown[]) {
  const didMountRef = React.useRef(false);

  // eslint-disable-next-line consistent-return
  React.useEffect(() => {
    if (didMountRef.current) {
      const cleanup = effect();
      if (cleanup) {
        return () => cleanup();
      }
    }
    didMountRef.current = true;
  }, [...deps]);
}
